<template>
    <div id="pt431" class="pt431">
        <breadcrumb :navListCustom="[{title:'マイページ', routerName: pt431DoInit.myPage, param: {pageNo: '81'}}, {title:$t('pt430.labels.title'), routerName: '', param: {pageNo: '81'}}]"></breadcrumb>
        <div>
            <!-- マイページ -->
            <div class="itemtitle">
                <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
            </div>
            <div class="section-inner">
                <!-- お支払い方法の選択 -->
                <h3 class="sectionTitle">{{$t('pt431.labels.title')}}</h3>
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt430'"/>
                <!--ご希望の支払い方法を選択してください。 -->
                <p>{{$t("sh050.labels.preferredPaymentMethod")}}</p>
                <!-- Message1 -->

                <iframe name="dummyframe" id="dummyframe" ref="dummyframe" style="display:none"></iframe>

                <table class="payChangeTable">
                    <tbody v-for="(obj,index) in pt431SiharaiHohoKbnList" :key="index">
                        <template>
                                <!-- 代引き、払込票が使えないパターン -->
                                <template v-if="pt431ReqModel.daiNgFlg == 1 && pt431ReqModel.haraiNgFlg == 1">
                                    <!-- 代引きと払込票の決済CDの表示をしない -->
                                    <template v-if="obj.KEY == '2' || obj.KEY == '3'">
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <th>
                                                <input v-if="obj.KEY == pt431ReqModel.siharaiHohoKbn" type="radio" :value="obj.KEY" name="siharai_hoho_kbn"
                                                    :id="'_siharai_hoho_kbn_' + obj.KEY" checked="checked" @click="selectSiharaiHoho(obj)"/>
                                                <input v-else type="radio" :value="obj.KEY" name="siharai_hoho_kbn" @click="selectSiharaiHoho(obj)"
                                                    :id="'_siharai_hoho_kbn_' + obj.KEY"/>
                                                <label :for="'_siharai_hoho_kbn_' + obj.KEY" onClick="">
                                                    <strong>{{obj.VALUE}}</strong>
                                                </label>    
                                            </th>
                                            <td>
                                                <!--決済方法のメッセージ -->
                                                <span v-html="descriptionInfo[obj.KEY]"></span>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                <!-- 代引き、が使えないパターン -->
                                <template v-else-if="pt431ReqModel.daiNgFlg == 1">
                                    <!-- 代引きの決済CDの表示をしない -->
                                    <template v-if="obj.KEY == '2'"></template>
                                    <template v-else>
                                        <tr>
                                            <th>
                                                <input v-if="obj.KEY == pt431ReqModel.siharaiHohoKbn" type="radio" :value="obj.KEY" name="siharai_hoho_kbn"
                                                    :id="'_siharai_hoho_kbn_'+ obj.KEY"	checked="checked" @click="selectSiharaiHoho(obj)"/>
                                                <input v-else type="radio" :value="obj.KEY" name="siharai_hoho_kbn" @click="selectSiharaiHoho(obj)"
                                                    :id="'_siharai_hoho_kbn_'+ obj.KEY"/>
                                                <label :for="'_siharai_hoho_kbn_' + obj.KEY" onClick="">
                                                    <strong>{{obj.VALUE}}</strong>
                                                </label>
                                            </th>
                                            <td>
                                                <!--決済方法のメッセージ -->
                                                <span v-html="descriptionInfo[obj.KEY]"></span>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                <!-- 無条件で表示 -->
                                <template v-else>
                                    <tr v-if="obj.KEY != Constants.KESSAI_AMAZONPAY && obj.KEY != '993'">
                                        <th>
                                            <input v-if="obj.KEY == pt431ReqModel.siharaiHohoKbn" type="radio" :value="obj.KEY" name="siharai_hoho_kbn"
                                                :id="'_siharai_hoho_kbn_'+ obj.KEY" checked="checked" @click="selectSiharaiHoho(obj)"/>
                                            <input v-else type="radio" :value="obj.KEY" name="siharai_hoho_kbn" @click="selectSiharaiHoho(obj)"
                                                :id="'_siharai_hoho_kbn_'+ obj.KEY"/>
                                            <label :for="'_siharai_hoho_kbn_' + obj.KEY" onClick="">
                                                <strong>{{obj.VALUE}}</strong>
                                            </label>
                                        </th>
                                        <td>
                                            <span v-if="obj.KEY == '1' && cardFlg == 0 && pt431ReqModel.teikiFlg == 1|| obj.KEY == '1' && pt431ReqModel.teikiFlg == 0" v-html="descriptionInfo[obj.KEY]"></span>
                                            <table v-if="obj.KEY == '1' && cardFlg == 0 && pt431ReqModel.teikiFlg == 1|| obj.KEY == '1' && pt431ReqModel.teikiFlg == 0" class="creditTable" width="100%" style="width:100%" :summary="$t('sh060.labels.cardnumber')">
                                                <template v-if="obj.KESSAI_COMP_KBN == 'JCS' || obj.KESSAI_COMP_KBN == 'GMO' || obj.KESSAI_COMP_KBN == 'SGP' || obj.KESSAI_COMP_KBN == 'PAY' || obj.KESSAI_COMP_KBN == 'SPS'">
                                                    <form :action="pt431DoInit.serverUrl" 
                                                        METHOD="POST" ref="form" name="form" ENCTYPE="application/x-www-form-urlencode" target="dummyframe">

                                                        <input type="hidden" name="tourokuKbn" value="4">    <!-- 登録区分 -->
                                                        <input type="hidden" name="merchantId" :value="pt431DoInit.merchantId">    <!-- 加盟店ID -->
                                                        <input type="hidden" name="dbKey1" :value="pt431DoInit.newDbKey">    <!-- 加盟店ID -->
                                                        <input type="hidden" name="backUrl" :value="pt431DoInit.backUrl">    <!-- 戻りURL -->
                                                        <input type="hidden" name="cardKbn" value="9">    <!-- カード情報返却区分 -->
                                                        <input type="hidden" name="optionalAreaName1" value="coNo">
                                                        <input type="hidden" name="optionalAreaValue1" :value="pt431DoInit.coNo">    <!-- 会社NO -->
                                                        <input type="hidden" name="optionalAreaName2" value="kessaiCd">
                                                        <input type="hidden" name="optionalAreaValue2" :value="obj.KEY">    <!-- 決済方法CD -->
                                                        <input type="hidden" name="msgDigest" :value="pt431DoInit.msgDigest">    <!-- 注文受付メッセージダイジェスト -->
                                                        
                                                        <input type="hidden" name="pan" :value="pan">
                                                        <input type="hidden" name="expiryDate" :value="expiryDate">
                                                    </form>
                                                    <form v-if="obj.KESSAI_COMP_KBN == 'SPS'" :action="pt431DoInit.serverUrl" method="POST" ref="formSps3D" name="formSps3D" target="_self">
                                                        <input type="hidden" name="MerchantId" v-model="sps3DSAuthori.merchantId">
                                                        <input type="hidden" name="EncryptValue" v-model="sps3DSAuthori.encValue">
                                                    </form>

                                                    <tr>
                                                        <th>
                                                            <!-- カード番号 -->
                                                            {{$t('sh060.labels.cardnumber')}}
                                                        </th>
                                                        <td v-if="pt431DoInit.creditInpNumOption == 0">
                                                            <input-check type="tel" class="num" size="4" style=" width:80px;"
                                                                :maxlength="4" v-model="pt431ReqModel.cardNoDisp1" autocomplete="off" />
                                                            -
                                                            <input-check type="tel" class="num" size="4" style=" width:80px;"
                                                                :maxlength="4" v-model="pt431ReqModel.cardNoDisp2" autocomplete="off" />
                                                            -
                                                            <input-check type="tel" class="num" size="4" style=" width:80px;"
                                                                :maxlength="4" v-model="pt431ReqModel.cardNoDisp3" autocomplete="off" />
                                                            -
                                                            <input-check type="tel" class="num" size="4" style=" width:80px;"
                                                                :maxlength="4" v-model="pt431ReqModel.cardNoDisp4" autocomplete="off" />
                                                        </td>
                                                        <td v-else>
                                                            <input-check type="tel" class="num" size="20" style=" width:50%;"
                                                                :maxlength="20" v-model="pt431ReqModel.cardNoDisp" autocomplete="off" @on-input-change="onCredit" @input="onCredit"/>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <!-- 有効期限 -->
                                                            {{$t('sh060.labels.expirationdate')}}
                                                        </th>
                                                        <td v-if="pt431DoInit.ymPulldownFlg == 1">
                                                            <select v-model="pt431ReqModel.limitMonth" name="limitMonth" id="limitMonth">
                                                                <option v-for="payCnt in pt431DoInit.monKbnList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                            </select>/
                                                            <select v-model="pt431ReqModel.limitYear" name="limitYear" id="limitYear">
                                                                <option v-for="payCnt in pt431DoInit.yearList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                            </select>
                                                        </td>
                                                        <td v-else>
                                                            <input-check type="tel" class="num" size="2"
                                                                maxlength="2" v-model="pt431ReqModel.limitMonth"
                                                                name="limitMonth" id="limitMonth" autocomplete="off" @on-input-change="onBlur"/>
                                                                <!-- 月／20 -->
                                                                {{$t('sh060.labels.month')}}／20
                                                            <input-check type="tel" class="num" size="2"
                                                                maxlength="2" v-model="pt431ReqModel.limitYear"
                                                                name="limitYear" id="limitYear"
                                                                onKeyPress="_chkInp();" autocomplete="off" />
                                                                <!-- 年 -->
                                                                {{$t('sh060.labels.year')}}
                                                        </td>
                                                    </tr>
                                                    <!--GMO,PAYの場合のみ名義人表示-->
                                                    <tr v-if="obj.KESSAI_COMP_KBN == 'GMO'|| obj.KESSAI_COMP_KBN == 'PAY' || obj.KESSAI_COMP_KBN == 'SPS'">
                                                        <!-- カードの名義人 -->
                                                        <th>{{$t('sh060.labels.cardHolder')}}</th>
                                                        <td v-if="pt431DoInit.cardNameOption == 1">
                                                            <span v-html="descriptionInfo2['1']"></span>
                                                            <!-- 名前 -->
                                                            <input-check type="text"
                                                                size="10"
                                                                name="cardNameNamae"
                                                                maxlength="50"
                                                                class="code" id="cardNameNamae"
                                                                v-model="pt431ReqModel.cardNameNamae"
                                                                autocomplete="off" :placeholder="descriptionInfo2[6]"/>
                                                            <span v-html="descriptionInfo2['2']"></span>
                                                            <input-check type="text" size="10" maxlength="50"
                                                                name="cardNameMyouji" class="code" id="cardNameMyouji"
                                                                v-model="pt431ReqModel.cardNameMyouji"
                                                                autocomplete="off" :placeholder="descriptionInfo2[7]"/>
                                                            <br />
                                                            <span v-html="descriptionInfo2['3']"></span>
                                                        </td>
                                                        <td v-else>
                                                            <!-- 名前 -->
                                                            <input type="text" size="20" name="cardUserNm"
                                                                maxlength="100" id="cardUserNm"
                                                                v-model="pt431ReqModel.cardUserNm" autocomplete="off" :placeholder="descriptionInfo2[5]"/>
                                                            <span v-html="descriptionInfo2['3']"></span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="pt431DoInit.securityCodeUseFlg">
                                                        <th>
                                                            <!-- セキュリティコード -->
                                                            {{$t('sh060.labels.securitycode')}}
                                                        </th>
                                                        <td>
                                                            <input-check type="text" size="4" maxlength="4" name="cardSecurity" class="numcode"
                                                                id="cardSecurity"
                                                                v-model="pt431ReqModel.securityCode"
                                                                autocomplete="off"/>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <!-- お支払方法 -->
                                                            {{$t('sh060.labels.paymentMethod')}}
                                                        </th>
                                                        <td>
                                                            <select v-model="pt431ReqModel.cardPayCnt" name="cardPayCnt" id="cardPayCnt" @change="chgCardPayModel">
                                                                <option v-for="payCnt in pt431DoInit.payCntList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                            </select>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="isBunkatu==true">
                                                        <th>
                                                            <!-- お支払回数 -->
                                                            {{$t('sh060.labels.paymentfrequency')}}
                                                        </th>
                                                        <td>
                                                            <select v-model="pt431ReqModel.bunkatuKaisu" name="bunkatuKaisu" id="bunkatuKaisu">
                                                                <option v-for="kaisu in pt431DoInit.bunkatuKaisuList" :key="kaisu.KEY" :value="kaisu.KEY">{{kaisu.VALUE}}</option>
                                                            </select>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-else>
                                                    <tr>
                                                        <th>
                                                            <!-- カード番号 -->
                                                            {{$t('sh060.labels.cardnumber')}}
                                                        </th>
                                                        <td v-if="pt431DoInit.creditInpNumOption == 0">
                                                            <input-check type="text" class="num" size="4" id="cardNoDisp1"
                                                                maxlength="4" v-model="pt431ReqModel.cardNoDisp1" autocomplete="off" />
                                                            -
                                                            <input-check type="text" class="num" size="4"
                                                                maxlength="4" name="cardNoDisp2" v-model="pt431ReqModel.cardNoDisp2" id="cardNoDisp2" autocomplete="off" />
                                                            -
                                                            <input-check type="text" class="num" size="4"
                                                                maxlength="4" name="cardNoDisp3" v-model="pt431ReqModel.cardNoDisp3" id="cardNoDisp3" autocomplete="off" />
                                                            -
                                                            <input-check type="text" class="num" size="4"
                                                                maxlength="4" name="cardNoDisp4" 
                                                                v-model="pt431ReqModel.cardNoDisp4" id="cardNoDisp4" autocomplete="off" />
                                                        </td>
                                                        <td v-else>
                                                            <input-check type="tel" class="num" size="20" style=" width:50%;"
                                                                :maxlength="20" v-model="pt431ReqModel.cardNoDisp" autocomplete="off" @on-input-change="onCredit" @input="onCredit"/>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <!-- 有効期限 -->
                                                            {{$t('sh060.labels.expirationdate')}}
                                                        </th>
                                                        <td v-if="pt431DoInit.ymPulldownFlg == 1">
                                                            <select v-model="pt431ReqModel.limitMonth" name="limitMonth" id="limitMonth">
                                                                <option v-for="payCnt in pt431DoInit.monKbnList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                            </select>/
                                                            <select v-model="pt431ReqModel.limitYear" name="limitYear" id="limitYear">
                                                                <option v-for="payCnt in pt431DoInit.yearList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                            </select>
                                                        </td>
                                                        <td v-else>
                                                            <input-check type="tel" class="num" size="2"
                                                                maxlength="2" v-model="pt431ReqModel.limitMonth"
                                                                name="limitMonth" id="limitMonth" autocomplete="off" @on-input-change="onBlur"/>
                                                                <!-- 月／20 -->
                                                                {{$t('sh060.labels.month')}}／20
                                                            <input-check type="tel" class="num" size="2"
                                                                maxlength="2" v-model="pt431ReqModel.limitYear"
                                                                name="limitYear" id="limitYear"
                                                                autocomplete="off" />
                                                                <!-- 年 -->
                                                                {{$t('sh060.labels.year')}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <!-- カードの名義人 -->
                                                            {{$t('sh060.labels.cardHolder')}}
                                                        </th>
                                                        <td>
                                                            <span v-html="descriptionInfo2['1']"></span>
                                                            <!-- 名前 -->
                                                            <input-check type="text"
                                                                size="10"
                                                                name="cardNameNamae"
                                                                maxlength="50"
                                                                class="code" id="cardNameNamae"
                                                                v-model="pt431ReqModel.cardNameNamae"
                                                                autocomplete="off"/>
                                                            <span v-html="descriptionInfo2['2']"></span>
                                                            <input-check type="text" size="10" maxlength="50"
                                                                name="cardNameMyouji" class="code" id="cardNameMyouji"
                                                                v-model="pt431ReqModel.cardNameMyouji"
                                                                autocomplete="off"/>
                                                            <br />
                                                            <span v-html="descriptionInfo2['3']"></span>
                                                        </td>
                                                    </tr>
                                                
                                                    <tr>
                                                        <th>
                                                            <!-- お支払回数 -->
                                                            {{$t('sh060.labels.paymentfrequency')}}
                                                        </th>
                                                        <td>
                                                            <select v-model="pt431ReqModel.cardPayCnt" name="cardPayCnt" id="cardPayCnt">
                                                                <option v-for="payCnt in pt431DoInit.payCntList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                            </select>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="pt431DoInit.securityCodeUseFlg">
                                                        <th>
                                                            <!-- セキュリティコード -->
                                                            {{$t('sh060.labels.securitycode')}}
                                                        </th>
                                                        <td>
                                                            <input-check type="text" size="4" maxlength="4" name="cardSecurity" class="numcode"
                                                                id="cardSecurity"
                                                                v-model="pt431ReqModel.cardSecurity"
                                                                autocomplete="off"/>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </table>
                                            <!--登録済のクレジットカード-->
                                            <template v-else-if="obj.KEY == '1' && pt431DoInit.cardNo != undefined && pt431DoInit.cardNo != ''">
                                                {{ pt431DoInit.cardNo }}<br/>
                                                {{ pt431DoInit.cardLimitYYYY }}/{{ pt431DoInit.cardLimitMM }}
                                                <input type="button" :value="$t('pt431.buttons.change')" :alt="$t('pt431.buttons.change')" @click="change" class="change">
                                                <table v-if="pt431ReqModel.teikiFlg == 1" class="creditTable" width="100%" style="width:100%" :summary="$t('sh060.labels.cardnumber')">
                                                    <tr>
                                                        <th>
                                                            <!-- お支払方法 -->
                                                            {{$t('sh060.labels.paymentMethod')}}
                                                        </th>
                                                        <td>
                                                            <select v-model="pt431ReqModel.cardPayCnt" name="cardPayCnt" id="cardPayCnt" @change="chgCardPayModel">
                                                                <option v-for="payCnt in pt431DoInit.payCntList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                            </select>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="isBunkatu==true">
                                                        <th>
                                                            <!-- お支払回数 -->
                                                            {{$t('sh060.labels.paymentfrequency')}}
                                                        </th>
                                                        <td>
                                                            <select v-model="pt431ReqModel.bunkatuKaisu" name="bunkatuKaisu" id="bunkatuKaisu">
                                                                <option v-for="kaisu in pt431DoInit.bunkatuKaisuList" :key="kaisu.KEY" :value="kaisu.KEY">{{kaisu.VALUE}}</option>
                                                            </select>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </template>
                                            <!--決済方法のメッセージ -->
                                            <span v-else v-html="descriptionInfo[obj.KEY]"></span>
                                        </td>
                                    </tr>
                                </template>
                        </template>
                    </tbody>
                </table>
                <!-- 定期詳細画面からの遷移の場合 -->
                <ul class="payChangeBtn" v-if="pt431ReqModel.teikiNo">
                    <!-- 戻るボタン -->
                    <li>
                        <input type="button" :value="$t('common.buttons.return')" :alt="$t('common.buttons.return')" @click="backPage" class="btnSubmit">
                    </li>
                    <!-- 全ての定期分の決済方法を変更 -->
                    <li>
                        <input type="button" :value="$t('pt431.buttons.submit2')" :alt="$t('pt431.buttons.submit2')" @click="confirmUpdate('1')" class="btnSubmit">
                    </li>
                    <!-- 個別で定期分の決済方法の変更 -->
                    <li>
                        <input type="button" :value="$t('pt431.buttons.teiki')" :alt="$t('pt431.buttons.teiki')" @click="confirmUpdate('2')" class="btnSubmit">
                    </li>
                </ul>
                <!-- 購入履歴または定期一覧からの遷移 -->
                <ul class="payChangeBtn" v-else>
                    <!-- 戻るボタン -->
                    <li>
                        <input type="button" :value="$t('common.buttons.return')" :alt="$t('common.buttons.return')" @click="backPage" class="btnSubmit">
                    </li>
                    <!-- 支払い方法を確定する -->
                    <li>
                        <input type="button" :value="$t('pt431.buttons.submit')" :alt="$t('pt431.buttons.submit')" @click="confirmUpdate('1')" class="btnSubmit">
                    </li>
                </ul>
            </div>
            <!-- modal confirm area -->
            <alert-confirm 
                v-if="isModalShow"
                :msgConfirm="msgConfirm"
                :okAction="doAction"
                @closedModal="isModalShow = false">
            </alert-confirm>
        </div>
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import $ from 'jquery';
import common from "assets/js/common";
import axios from "assets/js/request";
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import Constants from 'assets/const/Constants.json';
import InputNumber from "components/InputNumber";
import InputCheck from 'components/InputCheck.vue';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import Loading from 'vue-loading-overlay';
import AlertConfirm from 'components/AlertConfirm';
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "3000",
};

export default {
    /* 
    * Name of component
    */
    name: "PT431MemberOrderPayChangeParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },

    /* 
    * Get data from parent component
    */
    components:
    {
		EventBus,
		Message,
		InputNumber,
        InputCheck,
        Loading,
        Breadcrumb,
        AlertConfirm,
        toastr
    },
    data() {
        return {
            isBunkatu:false,
            isModalShow: false,
            pt431DoInit:{},
            pt431SiharaiHohoKbnList:{},
            listIdErr:[],
            pt431ReqModel:{},
            descriptionInfo:null,
            descriptionInfo2:null,
            SiteConstants: SiteConstants,
            Constants: Constants,
            PT431_PART:'pt431',
            listMessValid:[],
            mapMessValid:[],
            site: "",
            timer: '',
            cardFlg:0,
            sps3DSAuthori: {
                encValue: '',
                merchantId: '',
            }
        }
    },
    /*
    * 初期処理
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        _this.pt431ReqModel.clientHost = window.location.protocol + "//" + window.location.host;

        // sps 3d
        if (_this.spsResultId) {
            _this.pt431ReqModel.siharaiHohoKbn = '1';
            _this.pt431ReqModel.spsResultId = _this.spsResultId;
            _this.update();
            _this.removeParams();
        }

        // eslint-disable-next-line
        if (_this.ptInitData){
            _this.pt431DoInit = _this.ptInitData;
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT431 + _this.$UrlConstants.DO_INIT ,_this.pt431ReqModel).then(function(response) {
                _this.pt431DoInit = response.data;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        _this.pt431SiharaiHohoKbnList = _this.pt431DoInit.resultSiharaiHohoKbnList;
        let teikiFlg = _this.pt431ReqModel.teikiFlg;
        _this.pt431ReqModel = $.extend(_this.pt431ReqModel, _this.pt431DoInit.reqModel);
        _this.pt431ReqModel.teikiFlg = teikiFlg;//定期フラグを保持
        _this.descriptionInfo = _this.pt431DoInit.descriptionInfo;
        _this.descriptionInfo2 = _this.pt431DoInit.descriptionInfo2;

        if (_this.pt431DoInit.payCntList.length > 0) {
            _this.pt431ReqModel.cardPayCnt = _this.pt431DoInit.payCntList[0]['KEY'];
        }

        for (let i = 0; i < _this.pt431SiharaiHohoKbnList.length; i++) {
            if (_this.pt431SiharaiHohoKbnList[i].KEY == "1") {
                _this.pt431ReqModel.kessaiCompKbn = _this.pt431SiharaiHohoKbnList[i].KESSAI_COMP_KBN;
                break;
            }
        }
        if (common.isNullItem(_this.pt431DoInit.cardNo)) {
            _this.cardFlg = 0;
        } else {
            _this.cardFlg = 1;
        }

        //Call method selectLink when selecting links on DataTable
        EventBus.$on("select-link", function(selectData) {
            _this.selectLink(selectData);
        });
    },
    methods: {
        confirmUpdate: function(teikiFlg){
            var _this = this;
            _this.msgConfirm = this.$i18n.t('pt431.messages.confirm')
            _this.isModalShow = true;
            _this.actionFlg = 1;
            _this.teikiFlgParam = teikiFlg;
        },
        /*
        * 支払い方法確定処理
        */
        submit: function(teikiFlg){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT431_PART);

            if (!_this.pt431ReqModel.siharaiHohoKbn) {
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.paymentMethodMustErr'));
                EventBus.$emit('message', {});
                return;
            }

            _this.$emit("event-loading", true);
            // クレジット新規を選択した場合
            if (_this.pt431ReqModel.siharaiHohoKbn == '1' && _this.cardFlg == 0) {
                // 選択した決済情報、トークンURL、ショップIDを取得する
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT431 + _this.$UrlConstants.DO_AJAX,_this.pt431ReqModel).then(function(response) {
                    _this.pt431DoInit.tokenUrl = response.data.tokenUrl;
                    _this.pt431DoInit.merchantId = response.data.merchantId;
                    _this.pt431DoInit.serviceId = response.data.serviceId;
                    _this.pt431DoInit.apiPass2 = response.data.apiPass2;
                    _this.pt431DoInit.tokenNinsyoCode = response.data.tokenNinsyoCode;
                    _this.pt431DoInit.serverUrl = response.data.serverUrl;
                    _this.pt431DoInit.shopId = response.data.shopId;

                    if (teikiFlg == '1') {
                        _this.pt431ReqModel.teikiAllUpdateFlg = teikiFlg;
                    }else{
                        _this.pt431ReqModel.teikiAllUpdateFlg = "";
                    }
                    if (_this.pt431ReqModel.kessaiCompKbn == 'JCS') {
                        _this.saveJcs();
                    } else if (_this.pt431ReqModel.kessaiCompKbn == 'SBP') {
                        _this.doSbp();	
                    } else if (_this.pt431ReqModel.kessaiCompKbn == 'PAY') {
                        _this.doPayG();	
                    } else if (_this.pt431ReqModel.kessaiCompKbn == 'SPS') {
                        _this.doSps();
                    } else if (_this.pt431ReqModel.kessaiCompKbn == 'GMO') {
                        _this.doPurchase();
                    } else {
                        // カード情報チェック
                        if(!_this.cardCheck()) {
                            _this.$emit("event-loading", false);
                            return;
                        }
                        _this.teikiAll(teikiFlg);
                        _this.update();
                    }

                }).catch(function(error) {
                    common.errorAPI(error);
                    _this.$emit("event-loading", false);
                    return;
                });
            // クレジット既存を選択した場合
            } else if (_this.pt431ReqModel.siharaiHohoKbn == '1' && _this.cardFlg == 1) {
                _this.teikiAll(teikiFlg);
                _this.update();
            // それ以外の決済方法の場合
            } else {
                // 分割回数クリア
                _this.pt431ReqModel.bunkatuKaisu = '';
                _this.teikiAll(teikiFlg);
                _this.update();
            }
            _this.$emit("event-loading", false);
        },
        /*
        * 全ての定期更新の場合
        */
        teikiAll: function(teikiFlg){
            var _this = this;
            if (teikiFlg == '1') {
                _this.pt431ReqModel.teikiAllUpdateFlg = teikiFlg;
            }else{
                _this.pt431ReqModel.teikiAllUpdateFlg = "";
            }
        },
        /*
        * GMOトークン取得
        */
        doPurchase : function() {
            var _this = this;
            var cardno,expire,securitycode,holdername,tokennumber;
            // カード入力項目が1枠の場合
             if (this.pt431DoInit.creditInpNumOption == 1) {
                // カード番号
                cardno = this.pt431ReqModel.cardNoDisp;
                if (cardno) {
                    cardno = cardno.replaceAll(' ','');
                } 
             } else {
                // カード番号
                cardno = this.pt431ReqModel.cardNoDisp1 + this.pt431ReqModel.cardNoDisp2 + this.pt431ReqModel.cardNoDisp3 + this.pt431ReqModel.cardNoDisp4;
             }
            // 有効期限
            expire = this.pt431ReqModel.limitYear + this.pt431ReqModel.limitMonth;
            // セキュリティコード
            securitycode = this.pt431ReqModel.cardSecurity;
            // 名義人
            holdername = this.pt431ReqModel.cardUserNm;
            if (this.pt431DoInit.cardNameOption == 1) {
                holdername = this.pt431ReqModel.cardNameNamae + ' ' + this.pt431ReqModel.cardNameMyouji;
            }
            // 取得したいトークンの数
            tokennumber = '2';
            // トークン取得のURL
            var apiUrl = this.pt431DoInit.tokenUrl;
            var shopId = this.pt431DoInit.shopId;
            // カード情報チェック
            if(!_this.cardCheck()) {
                return;
            }
            this.$loadScript(apiUrl) .then(() => {
                // eslint-disable-next-line
                Multipayment.init(shopId);
                // eslint-disable-next-line
                Multipayment.getToken(
                    {	cardno: cardno,
                        expire: expire,
                        securitycode: securitycode,
                        holdername: holdername,
                        tokennumber: tokennumber
                    },
                    function(response){
                        var errCode = response.resultCode;
                        if( errCode != '000' ){
                            if (errCode == '100') {
                                alert('カード番号は必須です。');
                            } else if (errCode == '101') {
                                alert('カード番号の値が不正です。');
                            } else if (errCode == '102') {
                                alert('カード番号の桁数に誤りがあります。');
                            } else if (errCode == '110') {
                                alert('有効期限は必須です。');
                            } else if (errCode == '111') {
                                alert('有効期限の値が不正です。');
                            } else if (errCode == '112') {
                                alert('有効期限の桁数に誤りがあります。');
                            } else if (errCode == '113') {
                                alert('有効期限の値が不正です。');
                            } else if (errCode == '121') {
                                alert('セキュリティコードの値が不正です。');
                            } else if (errCode == '122') {
                                alert('セキュリティコードの桁数に誤りがあります。');
                            } else if (errCode == '131') {
                                alert('名義人の値が不正です。');
                            } else if (errCode == '132') {
                                alert('名義人の桁数に誤りがあります。');
                            } else {
                                alert('内部処理エラーが発生しました。');
                            }
                        } else {
                            for (var token = 0; token < response.tokenObject.token.length; token++) {
                                if (token == 0) {
                                    _this.pt431ReqModel.token = response.tokenObject.token[token];
                                } else {
                                    _this.pt431ReqModel.token = _this.pt431ReqModel.token + "," + response.tokenObject.token[token];
                                }
                            }
                            //_this.pt431ReqModel.token = response.tokenObject.token[0];
                            _this.update();
                            return true;
                        }
                    }
                );
             })
            .catch(function(error) {
                console.log(error);
            });
        },
        /**
         * SBペイメントのトークン取得
         */
         doSbp: function() {
            const _this = this;

            // カード情報チェック
            if(!_this.cardCheck()) {
                return;
            }
            const cardno = _this.pt431DoInit.creditInpNumOption == 1
                ? _this.pt431ReqModel.cardNoDisp
                : _this.pt431ReqModel.cardNoDisp1
                    + _this.pt431ReqModel.cardNoDisp2
                    + _this.pt431ReqModel.cardNoDisp3
                    + _this.pt431ReqModel.cardNoDisp4;
            const currentYear = new Date().getFullYear().toString();
            const expiration = 
                currentYear.substring(0, 2) + _this.pt431ReqModel.limitYear + _this.pt431ReqModel.limitMonth;

            const apiUrl = _this.pt431DoInit.tokenUrl;
            _this.$loadScript(apiUrl).then(() => {
                com_sbps_system.generateToken({
                    merchantId: _this.pt431DoInit.merchantId,
                    serviceId: _this.pt431DoInit.serviceId,
                    ccNumber: cardno ? cardno.replaceAll(' ','') : '',
                    ccExpiration: expiration,
                    securityCode: _this.pt431ReqModel.cardSecurity,
                }, (response) => {
                    if (response.errorCode) {
                        const itemCode = response.errorCode.substring(2);
                        if (itemCode === '003') {
                            alert('クレジット番号に誤りがあります。');
                        } else if (itemCode === '004') {
                            alert('クレジット有効期限に誤りがあります。');
                        } else if (itemCode === '005') {
                            alert('セキュリティコードに誤りがあります。');
                        } else {
                            console.log(response.errorCode)
                            alert('内部処理エラーが発生しました。');
                        }
                        return false;
                    }
                    if (response.result === "OK") {
                        _this.pt431ReqModel.token = response.tokenResponse.token;
                        _this.pt431ReqModel.tokenKey = response.tokenResponse.tokenKey;
                        _this.update();
                    } else {
                        alert('トークン取得に失敗しました。');
                    }
                });
            });
        },
        /*
        *ペイジェントのトークン取得
        */
        doPayG: function(){
            var _this = this;
            // カード情報チェック
            if(!_this.cardCheck()) {
                return;
            }
            var tokenUrl = this.pt431DoInit.tokenUrl;
            // マーチャントID
            var machantoId = this.pt431DoInit.confText1;
            // トークン生成鍵
            var tokunSeiseikagi = this.pt431DoInit.apiPass2;
            var cardno = "";
            // カード入力項目が1枠の場合
            if (this.pt431DoInit.creditInpNumOption == 1) {
                // カード番号
                cardno = this.pt431ReqModel.cardNoDisp;
                cardno = cardno.replaceAll(' ','');
            } else {
                // カード番号
                cardno = this.pt431ReqModel.cardNoDisp1 + this.pt431ReqModel.cardNoDisp2 + this.pt431ReqModel.cardNoDisp3 + this.pt431ReqModel.cardNoDisp4;
            }
            // 名義人
            var holdername = this.pt431ReqModel.cardUserNm;
            if (this.pt431DoInit.cardNameOption == 1) {
                holdername = this.pt431ReqModel.cardNameNamae + ' ' + this.pt431ReqModel.cardNameMyouji;
            }

            this.$loadScript(tokenUrl).then(() => {
                // eslint-disable-next-line
                var paygentToken = new PaygentToken();
                paygentToken.createToken(
                    machantoId, //マーチャントID
                    tokunSeiseikagi, //トークン生成鍵
                    {
                    card_number:cardno, //クレジットカード番号
                    expire_year:this.pt431ReqModel.limitYear, //有効期限-YY
                    expire_month: this.pt431ReqModel.limitMonth, //有効期限-MM
                    cvc: this.pt431ReqModel.cardSecurity, //セキュリティーコード
                    name:holdername //カード名義
                    },function(response){
                        //正常終了
                        if(response.result == '0000'){
                            //トークン
                            _this.pt431ReqModel.token = response.tokenizedCardObject.token;
                            _this.pt431ReqModel.securityCode = "";
                            _this.update();
                        //エラー
                        }else{
                            if(response.result == '1100'){
                                alert('マーチャントID - 必須エラー');
                            }else if(response.result == '1200'){
                                alert('トークン生成公開鍵 - 必須エラー');
                            }else if(response.result == '1200'){
                                alert('トークン生成公開鍵 - 必須エラー');
                            }else if(response.result == '1201'){
                                alert('トークン生成公開鍵 - 不正エラー');
                            }else if(response.result == '1300'){
                                alert('カード番号 - 必須チェックエラー');
                            }else if(response.result == '1301'){
                                alert('カード番号 - 書式チェックエラー');
                            }else if(response.result == '1400'){
                                alert('有効期限(年) - 必須チェックエラー');
                            }else if(response.result == '1401'){
                                alert('有効期限(年) - 書式チェックエラー');
                            }else if(response.result == '1500'){
                                alert('有効期限(月) - 必須チェックエラー');
                            }else if(response.result == '1501'){
                                alert('有効期限(月) - 書式チェックエラー');
                            }else if(response.result == '1502'){
                                alert('有効期限(年月)が不正です。');
                            }else if(response.result == '1600'){
                                alert('セキュリティコード - 書式チェックエラー');
                            }else if(response.result == '1601'){
                                alert('セキュリティコード - 必須エラー（セキュリティコードトークンの場合）');
                            }else if(response.result == '1700'){
                                alert('カード名義 - 書式チェックエラー');
                            }else if(response.result == '7000'){
                                alert('非対応のブラウザです。');
                            }else if(response.result == '7001'){
                                alert('ペイジェントとの通信に失敗しました。');
                            }else if(response.result == '8000'){
                                alert('システムメンテナンス中です。');
                            }else if(response.result == '9000'){
                                alert('ペイジェント決済システム内部エラー');
                            }
                        }
                    }
                );
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        /**
         * ソニーペイメントのトークン取得
         */
         doSps: async function() {
            const _this = this;

            _this.pt431ReqModel.spsResultId = null;

            var cardnoTmp = "";
            // カード入力項目が1枠の場合
            if (_this.pt431DoInit.creditInpNumOption == 1) {
                // カード番号
                cardnoTmp = _this.pt431ReqModel.cardNoDisp;
                if (cardnoTmp !== undefined && cardnoTmp !== null && cardnoTmp !== '') {
                    cardnoTmp = cardnoTmp.replaceAll(' ','');
                }
            } else {
                // カード番号
                if (_this.pt431ReqModel.cardNoDisp1 !== undefined && _this.pt431ReqModel.cardNoDisp1 !== null && _this.pt431ReqModel.cardNoDisp1 !== '') {
                    cardnoTmp = cardnoTmp + _this.pt431ReqModel.cardNoDisp1;
                }
                if (_this.pt431ReqModel.cardNoDisp2 !== undefined && _this.pt431ReqModel.cardNoDisp2 !== null && _this.pt431ReqModel.cardNoDisp2 !== '') {
                    cardnoTmp = cardnoTmp + _this.pt431ReqModel.cardNoDisp2;
                }
                if (_this.pt431ReqModel.cardNoDisp3 !== undefined && _this.pt431ReqModel.cardNoDisp3 !== null && _this.pt431ReqModel.cardNoDisp3 !== '') {
                    cardnoTmp = cardnoTmp + _this.pt431ReqModel.cardNoDisp3;
                }
                if (_this.pt431ReqModel.cardNoDisp4 !== undefined && _this.pt431ReqModel.cardNoDisp4 !== null && _this.pt431ReqModel.cardNoDisp4 !== '') {
                    cardnoTmp = cardnoTmp + _this.pt431ReqModel.cardNoDisp4;
                }
            }
            // カード有効期限
            var expireTmp = "";
            if (_this.pt431ReqModel.limitMonth != undefined && _this.pt431ReqModel.limitMonth !== null && _this.pt431ReqModel.limitMonth !== '') {
                expireTmp = expireTmp + _this.pt431ReqModel.limitMonth;
            }
            if (_this.pt431ReqModel.limitYear != undefined && _this.pt431ReqModel.limitYear !== null && _this.pt431ReqModel.limitYear !== '') {
                expireTmp = expireTmp + _this.pt431ReqModel.limitYear;
            }

            if (_this.pt431ReqModel.siharaiHohoKbn == '1') {
                // バリデーション
                _this.listMessValid = [];
                let isError = false;
                if(cardnoTmp == null || cardnoTmp == undefined || cardnoTmp == ''){
                    // カード番号を入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
                    isError = true;
                } else {
                    if (cardnoTmp.length < 14 ) {
                        // カード番号の入力値に誤りがあります。14桁以上16桁以内の数字で入力してください。
                        _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoInputErr'));
                        isError = true;
                    }
                }
                if(expireTmp == null || expireTmp == undefined || expireTmp == ''){
                    // カード有効期限を入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
                    isError = true;
                } else {
                    if (expireTmp.length < 4 ) {
                        // カード有効期限の入力値に誤りがあります。半角数値（「月/年」）で入力してください。
                        _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateInputErr'));
                        isError = true;
                    }
                }
                // 名義人必須チェック
                if (_this.pt431DoInit.cardNameOption == 1) {
                    if(!_this.pt431ReqModel.cardNameMyouji || !_this.pt431ReqModel.cardNameNamae) {
                        _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                        isError = true;
                    }
                } else {
                    if(!_this.pt431ReqModel.cardUserNm){
                        _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                        isError = true;
                    }
                }

                if (_this.pt431DoInit.securityCodeUseFlg) {
                    if(!_this.pt431ReqModel.securityCode) {
                        // セキュリティコードを入力してください。
                        _this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                        isError = true;
                    }
                }

                //お支払方法
                if(!_this.pt431ReqModel.cardPayCnt) {
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.paymentMethodMustErr'));
                    isError = true;
                }

                if (isError) {
                    _this.$emit("event-loading", false);
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return true;
                }
            }
            
            // SPSトークン取得
            const loadScriptSps = (url) => {
                return new Promise((resolve, reject) => {
                    if (document.querySelector('script[src="' + url + '"]')) {
                        return resolve();
                    }

                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = url;
                    script.setAttribute('callBackFunc', 'setToken');
                    script.setAttribute('class', 'spsvToken');
        
                    script.addEventListener('load', resolve);
                    script.addEventListener('error', reject);
                    script.addEventListener('abort', reject);
        
                    document.head.appendChild(script);
                });
            };

            const cardno = _this.pt431DoInit.creditInpNumOption == 1
                ? _this.pt431ReqModel.cardNoDisp
                : _this.pt431ReqModel.cardNoDisp1
                    + _this.pt431ReqModel.cardNoDisp2
                    + _this.pt431ReqModel.cardNoDisp3
                    + _this.pt431ReqModel.cardNoDisp4;
            const expirationYear = _this.pt431ReqModel.limitYear;
            const expirationMonth =  _this.pt431ReqModel.limitMonth;

            const apiUrl = `${_this.pt431DoInit.tokenUrl}?k_TokenNinsyoCode=${_this.pt431DoInit.tokenNinsyoCode}`;
            await loadScriptSps(apiUrl);

            SpsvApi.spsvCreateToken(
                cardno ? cardno.replaceAll(' ','') : '', // 第１引数：カード番号
                expirationYear, // 第２引数：有効期限（年）
                expirationMonth, // 第３引数：有効期限（年）
                _this.pt431ReqModel.securityCode, // 第４引数：セキュリティコード
                '', // 第６引数：生年月日（日）
                '', // 第７引数：電話番号
                '', // 第８引数：カナ氏名（姓）
                '', // 第９引数：カナ氏名（名）
            );

            // タイムアウト
            const timeId = setTimeout(() => {
                window.removeEventListener('message', handleMessage);
                alert('トークン取得に失敗しました。');
                return false;
            }, spsvGetParam('timeOut'));

            // メッセージイベントからトークンを取得する
            const handleMessage = (event) => {
                if (event.origin !== null && event.origin !== '' && event.origin !== undefined && event.origin != 'null') {
                    if (event.origin !== spsvGetParam('spsvOrigin')) {
                        if (event.origin.indexOf(spsvGetParam('spsvOrigin')) == -1) {
                            return;
                        }
                    }
                }
                try {
                    const message = JSON.parse(event.data);
                    if (
                        message.spsvOrigin !== null &&
                        message.spsvOrigin !== '' &&
                        message.spsvOrigin !== undefined &&
                        message.spsvOrigin != 'null'
                    ) {
                        if (message.spsvOrigin !== spsvGetParam('spsvOrigin')) {
                            return;
                        }
                        if (typeof message.tokenKbn == 'undefined' && message.token && message.token !== 'maked') {
                            clearTimeout(timeId);
                            window.removeEventListener('message', handleMessage);
                            _this.pt431ReqModel.token = message.token;
                            _this.updateForSps();
                            return true;
                        }
                    }
                } catch (e) {
                    console.log(e);
                }
            }
            window.addEventListener('message', handleMessage);
        },
        /**
         * ソニーペイメント3DS呼び出し
         */
        doSps3DS: function(response) {
            this.saveParams();
            this.sps3DSAuthori.merchantId = response.merchantId;
            this.sps3DSAuthori.encValue = response.encValue;
            
            this.$nextTick(() => this.$refs.formSps3D[0].submit()); 
        },
        /**
         * パラメータをsessionStorageに保存
         */
        saveParams: function() {
            const _this = this;
            _this.removeParams();
            if (_this.pt431ReqModel.orderCdTypical) {
                sessionStorage.setItem('orderCdTypical', _this.pt431ReqModel.orderCdTypical);
            }
            if (_this.pt431ReqModel.orderCd) {
                sessionStorage.setItem('orderCd', _this.pt431ReqModel.orderCd);
            }
            if (_this.pt431ReqModel.teikiFlg) {
                sessionStorage.setItem('teikiFlg', _this.pt431ReqModel.teikiFlg);
            }
            if (_this.pt431ReqModel.teikiNo) {
                sessionStorage.setItem('teikiNo', _this.pt431ReqModel.teikiNo);
            }
            if (_this.pt431ReqModel.teikiCdTypical) {
                sessionStorage.setItem('teikiCdTypical', _this.pt431ReqModel.teikiCdTypical);
            }
            if (_this.pt431ReqModel.cardPayCnt) {
                sessionStorage.setItem('cardPayCnt', _this.pt431ReqModel.cardPayCnt);
            }
            if (_this.pt431ReqModel.bunkatuKaisu) {
                sessionStorage.setItem('bunkatuKaisu', _this.pt431ReqModel.bunkatuKaisu);
            }
            if (_this.pt431ReqModel.backPageNo) {
                sessionStorage.setItem('backPageNo', _this.pt431ReqModel.backPageNo);
            }
        },
        /**
         * sessionStorageからパラメータを取得
         */
        restoreParams: function() {
            const _this = this;
            if (!_this.pt431ReqModel.orderCdTypical) {
                _this.pt431ReqModel.orderCdTypical = sessionStorage.getItem('orderCdTypical');
            }
            if (!_this.pt431ReqModel.orderCd) {
                _this.pt431ReqModel.orderCd = sessionStorage.getItem('orderCd');
            }
            if (!_this.pt431ReqModel.teikiFlg) {
                _this.pt431ReqModel.teikiFlg = sessionStorage.getItem('teikiFlg');
            }
            if (!_this.pt431ReqModel.teikiNo) {
                _this.pt431ReqModel.teikiNo = sessionStorage.getItem('teikiNo');
            }
            if (!_this.pt431ReqModel.teikiCdTypical) {
                _this.pt431ReqModel.teikiCdTypical = sessionStorage.getItem('teikiCdTypical');
            }
            if (sessionStorage.getItem('cardPayCnt')) {
                _this.pt431ReqModel.cardPayCnt = sessionStorage.getItem('cardPayCnt');
                 sessionStorage.removeItem('cardPayCnt');
            }
            if (sessionStorage.getItem('bunkatuKaisu')) {
                _this.pt431ReqModel.bunkatuKaisu = sessionStorage.getItem('bunkatuKaisu');
                 sessionStorage.removeItem('bunkatuKaisu');
            }
            if (!_this.pt431ReqModel.backPageNo) {
                _this.pt431ReqModel.backPageNo = sessionStorage.getItem('backPageNo');
            }
        },
        /**
         * パラメータをsessionStorageから除去
         */
        removeParams: function() {
            sessionStorage.removeItem('orderCdTypical');
            sessionStorage.removeItem('orderCd');
            sessionStorage.removeItem('teikiFlg');
            sessionStorage.removeItem('teikiNo');
            sessionStorage.removeItem('teikiCdTypical');
            sessionStorage.removeItem('cardPayCnt');
            sessionStorage.removeItem('bunkatuKaisu');
            sessionStorage.removeItem('backPageNo');
        },
        /*
        * カード番号を削除
        */
        cardNoDelete: function(){
            var _this = this;
            // カード番号
            _this.pt431ReqModel.cardNoDisp = "";
            _this.pt431ReqModel.cardNoDisp1 = "";
            _this.pt431ReqModel.cardNoDisp2 = "";
            _this.pt431ReqModel.cardNoDisp3 = "";
            _this.pt431ReqModel.cardNoDisp4 = "";
            // セキュリティコード
            _this.pt431ReqModel.cardSecurity = "";
            _this.pt431ReqModel.securityCode = "";
            // 名義人
            _this.pt431ReqModel.cardNameMyouji = "";
            _this.pt431ReqModel.cardNameNamae = "";
            _this.pt431ReqModel.cardUserNm = "";
            // 有効期限
            this.pt431ReqModel.limitYear = "";
            this.pt431ReqModel.limitMonth = "";

            if(this.pt431ReqModel.kessaiCompKbn !== "JCS" && this.pt431ReqModel.kessaiCompKbn !== "SGP" && this.pt431ReqModel.kessaiCompKbn !== "GMO" && this.pt431ReqModel.kessaiCompKbn !== "PAY" && this.pt431ReqModel.kessaiCompKbn !== "SPS") {
                this.pt431ReqModel.cardPayCnt = "";
            }
            
        },
        /*
        * 決済方法更新処理
        */
        update: function() {
            var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT431_PART);
			_this.$emit("event-loading", true);
            _this.cardNoDelete();
            _this.pt431ReqModel.cardFlg = _this.cardFlg;
            // 決済情報更新
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT431 + _this.$UrlConstants.DO_UPDATE,_this.pt431ReqModel).then(function(response) {
                _this.pt431ReqModel.securityCode = "";
                toastr.success(_this.$i18n.t('pt431.messages.msg'));
                if(response.data.status == "OK"){
                    // 購入履歴へ遷移
                    const parameter = _this.generateLinkParams(9, _this.pt431DoInit.orderHisPage);
                    _this.$router.push(parameter);
                }
                if(response.data.status == "OK2"){
                    // 定期一覧へ遷移
                    const parameter = _this.generateLinkParams(88, _this.pt431DoInit.teikiListPage);
                    _this.$router.push(parameter);
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
				_this.$emit("event-loading", false);
                    if(error != null && error != undefined){
                        _this.isModalShow = false;
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.PT431_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                            }else{
                                common.errorAPI(error);
                            }
                            if (error.response.data) {
                                if (_this.pt431ReqModel.kessaiCompKbn == "SPS" && error.response.data.model) {
                                    _this.pt431ReqModel.teikiFlg = error.response.data.model.teikiFlg;
                                    _this.pt431ReqModel.orderCdTypical = error.response.data.model.orderCdTypical;
                                }
                            }
                        }
                    }
                _this.removeParams();
				common.scrollTop();
            });
        },
        updateForSps: function() {
            var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT431_PART);
			_this.$emit("event-loading", true);
            _this.pt431ReqModel.pageNo = 82;
            // 決済情報更新
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT431 + _this.$UrlConstants.DO_UPDATE_FOR_SPS,_this.pt431ReqModel).then(function(response) {
                if (response.data.spsResultId && (response.data.operateId == '4MemAdd' || response.data.operateId == '4MemChg')) {
                    _this.pt431ReqModel.siharaiHohoKbn = '1';
                    _this.pt431ReqModel.orderCdTypical = response.data.orderId;
                    _this.pt431ReqModel.operateId = response.data.operateId;
                    _this.pt431ReqModel.cardPayCnt = response.data.cardBunKbn;
                    _this.updateFor3DAuthSps();
                    return;
                } else {
                    _this.doSps3DS(response.data);
                    return;
                }
            }).catch(function(error) {
				_this.$emit("event-loading", false);
                    if(error != null && error != undefined){
                        _this.isModalShow = false;
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.PT431_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
                _this.removeParams();
				common.scrollTop();
            }).finally(function() {
                _this.cardNoDelete();
            })
        },
        updateFor3DAuthSps: function() {
            var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT431_PART);
			_this.$emit("event-loading", true);
            _this.pt431ReqModel.pageNo = 82;
            // 決済情報更新
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT431 + _this.$UrlConstants.DO_UPDATE_FOR_SPS,_this.pt431ReqModel).then(function(response) {
                _this.doSps3DS(response.data);
                return;
            }).catch(function(error) {
				_this.$emit("event-loading", false);
                    if(error != null && error != undefined){
                        _this.isModalShow = false;
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.PT431_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
                _this.removeParams();
				common.scrollTop();
            }).finally(function() {
                _this.cardNoDelete();
            })
        },
        /*
        * Function selectLink
        */
        selectLink: function() {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 70}});
        },
        /*
        * クレジット変更ボタン
        */
        change: function() {
            var _this = this;
            var teikiNo;
            var teikiFlg;
            teikiNo = _this.pt431ReqModel.teikiNo;
            teikiFlg =_this.pt431ReqModel.teikiFlg;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 86}, params: {backPageNo: 82, teikiFlg: teikiFlg, teikiNo: teikiNo}});
        },
        /*
        * 戻るボタン
        */
		backPage: function(){
			var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            // 購入履歴
            var PageNo = "9";
            var customUrl = _this.pt431DoInit.orderHisPage;
            var teiki_no;
            if (_this.pt431ReqModel.backPageNo == "89") {
                // 定期詳細
                PageNo = _this.pt431ReqModel.backPageNo;
                teiki_no = _this.pt431ReqModel.teikiNo;
                customUrl = _this.pt431DoInit.teikiDtlPage;
            } else if (_this.pt431ReqModel.backPageNo == "88") {
                // 定期一覧
                PageNo = _this.pt431ReqModel.backPageNo;
                teiki_no = _this.pt431ReqModel.teikiNo;
                customUrl = _this.pt431DoInit.teikiListPage;
            }
            common.clearMessageEcSite(_this.listIdErr, _this.PT431_PART);
            const parameter = _this.generateLinkParams(PageNo, customUrl, {teiki_no: teiki_no, teiki_cd_typical: _this.pt431ReqModel.teikiCdTypical});
            _this.$router.push(parameter);
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
        /*
        *  execute update or delete or insert
        */
        doAction: function(){
            var _this = this;
            switch (this.actionFlg) {
                case 1:
                    this.submit(_this.teikiFlgParam);
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            _this.isModalShow = false;
            _this.actionFlg = 0;
            _this.teikiFlgParam = "1";
            _this.isButtonCancel = true;
        },
        selectSiharaiHoho: function(obj) {
            var _this = this;
            _this.pt431ReqModel.siharaiHohoKbn = obj.KEY;
            _this.pt431ReqModel.kessaiCompKbn = obj.KESSAI_COMP_KBN;
        },

        /*
        * updBunkatu:分割であるかどうか
        */
       updBunkatu: function(key) {
           if (this.pt431DoInit.payCntList.length > 0) {
               for (var i = 0; i < this.pt431DoInit.payCntList.length; i++){
                    var item = this.pt431DoInit.payCntList[i];
                    if(key == item.KEY && '1' == item.PARAM_MARK){
                        this.isBunkatu = true;
                        return;
                    }
               }
            }
            this.isBunkatu =  false;
       },

        chgCardPayModel() {
            this.pt431ReqModel.bunkatuKaisu = '';
            this.updBunkatu(this.pt431ReqModel.cardPayCnt);
            if(this.isBunkatu) {
                this.pt431ReqModel.bunkatuKaisu = this.pt431DoInit.bunkatuKaisuList[0]['KEY'];
            }
        },

        saveJcs() {
            let _this = this;

            _this.listMessValid = [];
            if(!_this.pan) {
                // カード番号を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
            } else if (_this.pan.length < 14 ) {
                // カード番号の入力値に誤りがあります。14桁以上16桁以内の数字で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoInputErr'));
            }
            if(!_this.expiryDate) {
                // カード有効期限を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
            } else if (_this.expiryDate.length < 4 ) {
                // カード有効期限の入力値に誤りがあります。半角数値（「月/年」）で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateInputErr'));
            }
            if(_this.pt431DoInit.securityCodeUseFlg) {
                if(!_this.pt431ReqModel.securityCode) {
                    // セキュリティコードを入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                }
            }

            //お支払方法
            if(!_this.pt431ReqModel.cardPayCnt) {
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.paymentMethodMustErr'));
            }

            if(_this.listMessValid.length > 0) {
                EventBus.$emit('message', {});
                common.scrollTop();
                return;
            }

            _this.$refs.form[0].submit();
            _this.cardNoDelete();

            _this.$emit("event-loading", true);

            var startTime = new Date().getTime();
            _this.timer = setInterval(function() {
                if(new Date().getTime() - startTime > 15 * 1000) {
                    clearInterval(_this.timer);
                    _this.doConfirm('');
                }
                let resp = _this.$refs['dummyframe'].contentWindow.document.body.innerHTML;
                if(resp && resp.indexOf('errCode') !== -1) {
                    clearInterval(_this.timer);
                    _this.doConfirm(resp);
                }
            }, 1000);
        },
        /*
        * カード情報チェック
        */
       cardCheck: function() {
            var _this = this;
            var cardNo = "";
            var cardYear = "";
            var cardMonth = "";
            var securitycode = "";

            cardYear = _this.pt431ReqModel.limitYear;
            cardMonth = _this.pt431ReqModel.limitMonth;
            // セキュリティコード _this.pt431ReqModel.cardSecurity が空の場合、_this.pt431ReqModel.securityCode　をセットする
            if (_this.pt431ReqModel.cardSecurity) {
                securitycode = _this.pt431ReqModel.cardSecurity;
            } else {
                securitycode = _this.pt431ReqModel.securityCode;
            }
            
            if (_this.pt431DoInit.creditInpNumOption == 1) {
                cardNo = _this.pt431ReqModel.cardNoDisp;
                if (cardNo != undefined) {
                    cardNo = cardNo.replaceAll(' ','');
                }
            } else {
                cardNo = _this.pt431ReqModel.cardNoDisp1 + _this.pt431ReqModel.cardNoDisp2 + _this.pt431ReqModel.cardNoDisp3 + _this.pt431ReqModel.cardNoDisp4;
            }
            // カード番号必須チェック
            if (cardNo == null || cardNo == undefined || cardNo == '' || Number.isNaN(cardNo) || cardNo.length < 14 || cardNo.length > 16) {
                // カード番号を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
            }
            // 有効期限必須チェック
            if ((cardYear == null || cardYear == undefined) || (cardMonth == null || cardMonth == undefined)) {
                // 有効期限を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
            }
            // 名義人必須チェック
            if (_this.pt431DoInit.cardNameOption == 1) {
                if(!_this.pt431ReqModel.cardNameMyouji || !_this.pt431ReqModel.cardNameNamae) {
                    _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                }
            } else {
                if(!_this.pt431ReqModel.cardUserNm){
                    _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                }
            }
            // セキュリティコード必須チェック
            if (_this.pt431DoInit.securityCodeUseFlg) {
                if (!securitycode) {
                    // セキュリティコードを入力してください。
                    this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                }
            }

            //お支払方法
            if(!_this.pt431ReqModel.cardPayCnt) {
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.paymentMethodMustErr'));
            }

            // エラーがある場合
            if(_this.listMessValid.length > 0) {
                EventBus.$emit('message', {});
                common.scrollTop();
                return false;
            }
            return true;
       },

        doConfirm(resp) {
            let _this = this;
            if (resp.indexOf('OLM-IT00000000') !== -1) {
                _this.pt431ReqModel.newDbKey = _this.pt431DoInit.newDbKey;
                _this.update();
            } else { 
                _this.$emit("event-loading", false);
                _this.listMessValid = [];
                // クレジットカード登録処理に失敗しました。申し訳ございませんが、しばらく時間をあけて定期購入画面からやり直してください。
                _this.listMessValid.push(_this.$i18n.t('pt431.messages.kessaiErr'));
                EventBus.$emit('message', {});
                common.scrollTop();
            }
        },
        // フォーカスが外れた時、月を前０をセットする
        onBlur: function() {
            var limMonth = this.pt431ReqModel.limitMonth;
            this.pt431ReqModel.limitMonth = limMonth.padStart(2, "0");
        },
        // クレジット番号の4桁区切りでスペースを入れる処理
        onCredit: function() {
            var cardNo = this.pt431ReqModel.cardNoDisp;
            const regexp = /^(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,4})?$/;
            const digits = cardNo.replace(/[^0-9]/g, '');
            this.pt431ReqModel.cardNoDisp = [...regexp.exec(digits)].slice(1).filter(e => e).join(' ');
        },
    },
    /*
    * destroy eventbus of page before close page
    */
    beforeDestroy: function() {
        clearInterval(this.timer);
        //close select-link eventbus
        EventBus.$off("select-link");
    },
    /*
    * Excute code after an instance is created
    */
    created: function(){
         var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        if(Object.keys(paramData).length > 0){
            _this.pt431ReqModel.orderCdTypical = paramData.orderNo;
            _this.pt431ReqModel.orderCd = paramData.orderNo;
            _this.pt431ReqModel.teikiFlg = paramData.teikiFlg;
            _this.pt431ReqModel.teikiNo = paramData.teikiNo;
            _this.pt431ReqModel.teikiCdTypical = paramData.teikiCdTypical;
            _this.pt431ReqModel.backPageNo = paramData.backPageNo;
        } else {
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:{pageNo:1}});
        }
        if (_this.$route.query) {
            if (_this.$route.query.spsResultId) {
                _this.spsResultId = _this.$route.query.spsResultId;
                _this.operateId = _this.$route.query.operateId;
                this.restoreParams();
            } else {
                if (!_this.pt431ReqModel.teikiFlg) {
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:{pageNo:1}});
                }
            }
        }
    },

    computed: {
        pan: function () {
            var cardNo;
            if (this.pt431DoInit.creditInpNumOption == 1) {
                cardNo = this.pt431ReqModel.cardNoDisp;
                if (cardNo != undefined) {
                    cardNo = cardNo.replaceAll(' ','');
                }
                return cardNo;
            } else {
                cardNo = this.pt431ReqModel.cardNoDisp1 + this.pt431ReqModel.cardNoDisp2 + this.pt431ReqModel.cardNoDisp3 + this.pt431ReqModel.cardNoDisp4;
            }
            return cardNo;
        },
        expiryDate: function() {
            return this.pt431ReqModel.limitMonth + this.pt431ReqModel.limitYear;
        }

    }
}
</script>
